export default {
  List: {
    Title: 'Loại khoản',
    DictionaryActivity: '/ Mục lục ngân sách / Loại khoản',
    Dictionary: 'Danh mục',
    TextPlaceholder: {
      Search: 'Tìm kiếm theo Mã loại khoản, Tên loại khoản',
    },
  },
  Detail: {
    Text: {
      BudgetKindItemCode: 'Mã loại khoản *',
      BudgetKindItemName: 'Tên loại khoản *',
      BudgetKindItemType: 'Thuộc loại',
    },
    TextTooltip: {
      BudgetKindItemCode: 'Mã loại khoản',
      BudgetKindItemName: 'Tên loại khoản',
    },
    ShowAlert: {
      BelongingChilde: `Không được chọn loại khoản <span class="color-green">{0}</span> thuộc chính nó`,
      Error: 'Không hợp lệ',
      ErrorBudgetKind: 'Loại khoản không hợp lệ. Vui lòng kiểm tra lại.',
      BudgetKindItem: 'Loại khoản',
    },
  },
  Transfer: {
    Title: 'Chuyển đổi Loại khoản',
    FromKindItem: 'Chuyển từ Loại khoản',
    ToKindItem: 'Chuyển đến Loại khoản',
    HasPeriod: 'Có điều kiện thời gian',
    ValidateTitle: 'Khoản không hợp lệ',
    ValidateContent: 'Khoản cũ và khoản mới không được trùng nhau. Vui lòng kiểm tra lại.',
    TransferSuccess: 'Chuyển đổi loại khoản thành công',
  }
};
